export default {
    key: '',
    courses: [],
    all_courses: [],
    loading: false,
    coureseId: '',
    name: '',
    description: '',
    vimeo_Id: '',
    resources: [],
    lesson_Id: '',
    total_progress: '0',
    resource_id: '',
    resource_type: '',
    allModules: [],
    allLesson: [],
    allResources: [],
    video_finish: false,
    module_selected: '',
    selected_course: {},
};